import React from 'react';

import DisplayComponent from 'formlabs-web-components/BaseComponents/DisplayComponent';
import Price from './Price';

const PricePlugin = props => {
  return <Price {...props} />;
};

export default DisplayComponent(PricePlugin);
